import GeneralDetailLayout from '../../../components/GeneralDetailLayout';
import CompanySectionContainer from '../../../components/CompanySectionContainer';
import { pagesText } from '../../../constants/pagesText';
import CompanyMembersTable from './components/CompanyMembersTable';
import useFetchCompanyMembers from './helpers/useFetchCompanyMembers';
import InviteUserDialog from './components/invite/InviteUserDialog';

const CompanyMembers = () => {
  const { data: users, lastElementRef, isLoading, isFetching, count } = useFetchCompanyMembers();

  return (
    <CompanySectionContainer>
      <GeneralDetailLayout
        title={`${pagesText.companyUsers.title} ${count ? `(${count})` : ''}`}
        layoutDirection="column"
        TitleComponent={InviteUserDialog}>
        <CompanyMembersTable
          isLoading={isLoading}
          users={users}
          isFetching={isFetching}
          ref={lastElementRef}
        />
      </GeneralDetailLayout>
    </CompanySectionContainer>
  );
};

export default CompanyMembers;
